/**
 * Global navigation action IDs - for command palette root level.
 * These actions navigate to different sections of the app.
 */
export const globalActionIds = {
  // Search category navigation
  searchOrders: "searchOrders",
  searchReturns: "searchReturns",
  searchCustomers: "searchCustomers",
  searchConversations: "searchConversations",
  searchPages: "searchPages",
  searchHelpArticles: "searchHelpArticles",
} as const;

export type GlobalActionId =
  (typeof globalActionIds)[keyof typeof globalActionIds];

const globalActionIdSet = new Set<string>(Object.values(globalActionIds));

export function isGlobalActionId(id: string): id is GlobalActionId {
  return globalActionIdSet.has(id);
}
